/**
 *
 * @param type 'include' | 'exclude'
 * @param string string to be tested
 * @param pattern regex pattern
 * @returns boolean
 */
export const validateRegex = ({
  type,
  string,
  pattern
}: {
  type: 'include' | 'exclude';
  string: string;
  pattern: string;
}): boolean => {
  const RegexExp = pattern ? RegExp(pattern) : null;

  if (!RegexExp) return false;

  switch (type) {
    case 'include':
      return RegexExp.test(string);
    case 'exclude':
      return !RegexExp.test(string);
    default:
      return false;
  }
};
